var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-thead",
    { staticClass: "custom-table__head" },
    [
      _vm._l(_vm.columns, function (column, key) {
        return _c("mds-th", { key: key, staticClass: "custom-table__header" }, [
          _vm._v("\n    " + _vm._s(_vm.translate(column)) + "\n  "),
        ])
      }),
      _vm._v(" "),
      _c("mds-th", {
        staticClass: "custom-table__header custom-table__header--action",
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }